import { isValidCEP, isValidCPF, isValidCNPJ, isValidEmail, isValidMobilePhone, isValidPhone } from '@brazilian-utils/brazilian-utils';


class ValidateUtil {

    static isValidCEP(cep: string): boolean {
        const _cep = cep.replace(/[^0-9]/g, "")
        return isValidCEP(_cep);
    }

    static isValidCPF(cpf: string): boolean {
        const _cpf = cpf.replace(/[^0-9]/g, "")
        return isValidCPF(_cpf);
    }

    static isValidCNPJ(cnpj: string): boolean {
        const _cnpj = cnpj?.replace(/[^a-zA-Z0-9]/g, '')?.toUpperCase() || "";
        const isAlphaNumeric = /[A-Z]/.test(_cnpj);
        return isValidCNPJ(_cnpj, isAlphaNumeric ? { version: 2 } : undefined);
    }

    static isValidEmail(email: string): boolean {
        return isValidEmail(email);
    }

    static isValidPhone(phone: string): boolean {
        const _phone = phone.replace(/[^0-9]/g, "")
        return _phone.length >= 11 ? isValidMobilePhone(_phone) : isValidPhone(_phone);
    }

}

export { ValidateUtil }